import React, { useState, useEffect } from 'react'
import axios from 'axios'
import LoadingControl from '../controls/Loading';
import DBSettings from '../controls/DBSettings';

const DBSettingsPane = (props) => {  
    
    const [state, setState] = useState({
        error: null,
        isLoaded: false,
        settings: null
    });

    async function getData() {
      
        const res = await axios("/db_settings");
        return res.data;
        }

    useEffect(() => {
   
        getData()
        .then(res => {
            setState({ error: null, isLoaded: true, settings: res });
        })
        .catch(err => {
            setState( {error: err, isLoaded: false, settings: null });
        });
    }, []);  
  
    if(state.error != null)
    {
        return (
            <div>
                <h3>{state.error.message}</h3>
            </div>
        );
    }
    else if (!state.isLoaded)
    {
        return (
            <div><LoadingControl/></div>
        );
    }
    else
    {
        return (
            <div>
                <DBSettings settings = {state.settings}/>
            </div>
        );   
    }
}
  
export default DBSettingsPane;